<template>
  <div id="custom-hight-risk-upload">
    <div class="columns">
      <div
        v-if="data.topic === 'nameTitle'"
        class="column"
      >
        <b-field id="title">
          <div data-test="edit-kyc-information--title-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.nameTitle"
              native-value="Mr."
              name="title"
            >
              {{ $t('kyc.mr') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.nameTitle"
              native-value="Miss."
              name="title"
            >
              {{ $t('kyc.miss') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.nameTitle"
              native-value="Mrs."
              name="title"
            >
              {{ $t('kyc.mrs') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('title') }}</span>
      </div>
      <div
        v-if="data.topic === 'firstNameInThai'"
        class="column"
      >
        <b-field id="first-name-thai">
          <b-input
            v-validate="'required'"
            v-model="form.firstNameInThai"
            :placeholder="$t('kyc.first_name_th')"
            name="first name (Thai)"
            autocomplete="disabled"
            data-test="edit-kyc-information--first-name-thai-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('first name (Thai)') }}</span>
      </div>
      <div
        v-if="data.topic === 'lastNameInThai'"
        class="column"
      >
        <b-field id="last-name-thai">
          <b-input
            v-validate="'required'"
            v-model="form.lastNameInThai"
            :placeholder="$t('kyc.last_name_th')"
            name="last name (Thai)"
            autocomplete="disabled"
            data-test="edit-kyc-information--last-name-thai-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('last name (Thai)') }}</span>
      </div>
    </div>
    <div class="columns">
      <div
        v-if="data.topic === 'firstName'"
        class="column"
      >
        <b-field id="first-name">
          <b-input
            v-validate="'required'"
            v-model="form.firstName"
            :placeholder="$t('kyc.first_name')"
            name="first name"
            autocomplete="disabled"
            data-test="edit-kyc-information--first-name-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('first name') }}</span>
      </div>
      <div
        v-if="data.topic === 'middleName'"
        class="column"
      >
        <b-field id="middle-name">
          <b-input
            v-model="form.middleName"
            :placeholder="$t('kyc.middle_name')"
            name="middle name"
            data-test="edit-kyc-information--middle-name-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('middle name') }}</span>
      </div>
      <div
        v-if="data.topic === 'lastName'"
        class="column"
      >
        <b-field id="last-name">
          <b-input
            v-validate="'required'"
            v-model="form.lastName"
            :placeholder="$t('kyc.last_name')"
            name="last name"
            autocomplete="disabled"
            data-test="edit-kyc-information--last-name-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('last name') }}</span>
      </div>
    </div>
    <div class="columns">
      <div
        v-if="data.topic === 'gender'"
        class="column"
      >
        <b-field id="gender">
          <div data-test="edit-kyc-information--gender-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.gender"
              native-value="Male"
              name="gender"
            >
              {{ $t('kyc.male') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.gender"
              native-value="Female"
              name="gender"
            >
              {{ $t('kyc.female') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('gender') }}</span>
      </div>
      <div
        v-if="data.topic === 'maritalStatus'"
        class="column"
      >
        <b-field id="marital-status">
          <div data-test="edit-kyc-information--marital-status-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.maritalStatus"
              native-value="Single"
              name="marital status"
            >
              {{ $t('kyc.single') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.maritalStatus"
              native-value="Married"
              name="marital status"
            >
              {{ $t('kyc.married') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('marital status') }}</span>
      </div>
    </div>
    <div class="columns">
      <div
        v-if="data.topic === 'birthdate'"
        class="column"
      >
        <b-field
          id="date-of-birth"
          data-test="edit-kyc-information--birthdate"
        >
          <b-datepicker
            v-validate="'required|ageMoreThanTwenty'"
            v-model="form.birthdate"
            :mobile-native="false"
            :years-range="[-200, 200]"
            :placeholder="$t('kyc.click_to_select')"
            icon="calendar-today"
            name="date of birth"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('date of birth') }}</span>
      </div>
      <div
        v-if="data.topic === 'tel'"
        class="column"
      >
        <b-field id="phone-number">
          <b-input
            v-validate="'required'"
            v-model="form.tel"
            :placeholder="$t('kyc.tel_placeholder')"
            name="phone number"
            autocomplete="disabled"
            data-test="edit-kyc-information--phone-number-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('phone number') }}</span>
      </div>
    </div>
    <div class="columns">
      <div
        v-if="data.topic === 'workingAtCompanyName'"
        class="column"
      >
        <b-field
          id="working-at-company"
          class="kyc-information-is-expanded"
        >
          <b-input
            v-validate="'required'"
            v-model="form.workingAtCompanyName"
            :placeholder="$t('kyc.company_placholder')"
            name="working at company"
            autocomplete="disabled"
            data-test="edit-kyc-information--working-at-company-field"
          />
        </b-field>
      </div>
    </div>
    <!-- Working at company address -->
    <div class="columns dp-flex">
      <div
        v-if="data.topic === 'workingAtCompanyAddressLineOne'"
        class="column"
      >
        <b-field id="origin-address">
          <b-input
            v-validate="'required'"
            v-model="form.workingAtCompanyAddressLineOne"
            :placeholder="$t('kyc.address_placeholder')"
            name="working at company address"
            autocomplete="disabled"
            expanded
            data-test="edit-kyc-information--working-at-company-address-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('working at company address') }}</span>
      </div>
    </div>
    <div class="columns dp-flex">
      <div
        v-if="data.topic === 'workingAtCompanyAddressLineTwo'"
        class="column"
      >
        <b-field>
          <b-input
            v-model="form.workingAtCompanyAddressLineTwo"
            :placeholder="$t('kyc.address_placeholder')"
            autocomplete="disabled"
            expanded
            data-test="edit-kyc-information--working-at-company-address-line-2-field"
          />
        </b-field>
      </div>
    </div>
    <div class="columns dp-flex">
      <div
        v-if="data.topic === 'workingAtCompanyCountry'"
        class="column"
      >
        <b-field
          id="origin-country"
          class="kyc-address-is-expanded"
        >
          <b-select
            v-validate="'required'"
            v-model="form.workingAtCompanyCountry"
            :placeholder="$t('kyc.country')"
            name="working at company country"
            data-test="edit-kyc-information--working-at-company-country-field"
          >
            <option
              v-for="(country, index) in countries"
              :value="country.en_short_name"
              :key="index"
              :disabled="country.disabled"
            >
              {{ country.en_short_name }}
            </option>
          </b-select>
        </b-field>
        <span class="is-invalid">{{ errors.first('working at company country') }}</span>
      </div>
    </div>
    <div class="columns dp-flex">
      <div
        v-if="data.topic === 'workingAtCompanyProvince'"
        class="column"
      >
        <b-field id="origin-province">
          <b-select
            v-validate="'required'"
            v-if="form.workingAtCompanyCountry ? form.workingAtCompanyCountry=== 'Thailand' : workingAtCompanyCountry === 'Thailand'"
            v-model="form.workingAtCompanyProvince"
            :placeholder="$t('kyc.province_placeholder')"
            name="working at company province"
            expanded
            data-test="edit-kyc-information--working-at-company-province-field"
          >
            <option
              v-for="province in provincesInThailand"
              :value="province.key"
              :key="province.key"
            >
              {{ province.th }}
            </option>
          </b-select>
          <b-input
            v-validate="'required'"
            v-else
            v-model="form.workingAtCompanyProvince"
            :placeholder="$t('kyc.province_placeholder')"
            name="working at company province"
            autocomplete="disabled"
            expanded
            data-test="edit-kyc-information--working-at-company-province-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('working at company province') }}</span>
      </div>
    </div>
    <div class="columns dp-flex">
      <div
        v-if="data.topic === 'workingAtCompanyCity'"
        class="column"
      >
        <b-field id="origin-city">
          <b-input
            v-validate="'required'"
            v-model="form.workingAtCompanyCity"
            :placeholder="$t('kyc.city_placeholder')"
            name="working at company city"
            autocomplete="disabled"
            expanded
            data-test="edit-kyc-information--working-at-company-city-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('working at company city') }}</span>
      </div>
      <div
        v-if="data.topic === 'workingAtCompanyPostcode'"
        class="column"
      >
        <b-field id="origin-postcode">
          <b-input
            v-validate="(form.workingAtCompanyCountry && form.workingAtCompanyCountry === 'Thailand') || workingAtCompanyCountry === 'Thailand' ? 'required|numeric|length:5' : 'required'"
            v-model="form.workingAtCompanyPostcode"
            :placeholder="$t('kyc.zipcode')"
            name="working at company postcode"
            autocomplete="disabled"
            expanded
            data-test="edit-kyc-information--working-at-company-postcode-field"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('working at company postcode') }}</span>
      </div>
    </div>
    <div class="columns">
      <div
        v-if="data.topic === 'career'"
        class="column"
      >
        <b-field
          id="occupation"
          class="kyc-information-is-expanded"
        >
          <b-select
            v-validate="'required'"
            v-model="form.career"
            :placeholder="$t('kyc.occupation')"
            name="occupation"
            data-test="edit-kyc-information--occupation-field"
          >
            <option
              v-for="occupation in sortOccupationList"
              :value="occupation.key"
              :key="occupation.key"
              name="occupation"
            >
              {{ occupation[$i18n.locale] }}
            </option>
          </b-select>
        </b-field>
        <span class="is-invalid">{{ errors.first('occupation') }}</span>
      </div>
    </div>
    <!-- Career 'Other' or 'Freelance' should specify detail -->
    <div
      v-if="data.topic === 'career' && ['OC54', 'OC47'].includes(form.career)"
      class="columns"
    >
      <div class="column">
        <div class="column">
          <b-field
            id="occupation-specify-detail"
            :label="$t('kyc.occupation_specify_detail')"
          >
            <b-input
              v-validate="'required'"
              v-model="form.careerOther"
              :placeholder="$t('kyc.occupation_specify_detail_placeholder')"
              name="occupation specify detail"
              data-test="kyc-information--working-at-occupation-specify-detail"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('occupation specify detail') }}</span>
        </div>
      </div>
    </div>
    <div class="columns">
      <!-- The average income -->
      <div
        v-if="data.topic === 'averageIncome'"
        class="column"
      >
        <b-field
          id="average-income"
          class="kyc-information-is-expanded"
        >
          <b-select
            v-validate="'required'"
            v-model="form.averageIncome"
            :placeholder="$t('kyc.avg_income')"
            name="average income"
            data-test="edit-kyc-upload-doc-hight-risk--average-income-field"
          >
            <option
              v-for="income in averageIncomeList"
              :value="income.key"
              :key="income.key"
              name="income"
            >
              {{ income[$i18n.locale] }}
            </option>
          </b-select>
        </b-field>
        <span class="is-invalid">{{ errors.first('average income') }}</span>
      </div>
    </div>
    <div class="columns">
      <!-- Proof of income -->
      <div
        v-if="data.topic === 'proofOfIncome'"
        class="column document-box"
      >
        <div class="example-img">
          <b-upload
            v-validate="'required'"
            v-model="form.proofOfIncome"
            name="proof income"
            accept="image/*,.pdf"
            drag-drop
            @input="(file) => onUploadDoc(file, 'proofOfIncome')"
          >
            <section
              class="section"
              data-test="edit-kyc-upload-doc-hight-risk--proof-income"
            >
              <div class="content has-text-centered">
                <img
                  src="/static/img/icon-company-cer-doc.png"
                  class="dropzone-img--certificate"
                >
              </div>
              <div class="browse-btn">
                {{ $t('kyc.browse_file') }}
              </div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('proof income') }}</span>
          <b-tag
            v-if="form.proofOfIncome"
            type="is-primary"
          >
            {{ form.proofOfIncome.name }}
          </b-tag>
          <div
            v-if="proofOfIncomeOverSize"
            class="is-invalid t-al-center"
          >
            {{ $t('kyc.doc_limit') }} {{ limitFileSizeInMb }} MB
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <!-- Evidence of asset ownership -->
      <div
        v-if="data.topic === 'assetOwnership'"
        class="column"
      >
        <div class="example-img">
          <b-upload
            v-validate="'required'"
            v-model="form.assetOwnership"
            name="asset ownership"
            accept="image/*,.pdf"
            drag-drop
            @input="(file) => onUploadDoc(file, 'assetOwnership')"
          >
            <section
              class="section"
              data-test="edit-kyc-upload-doc-hight-risk--asset-ownership"
            >
              <div class="content has-text-centered">
                <img
                  src="/static/img/icon-company-cer-doc.png"
                  class="dropzone-img--certificate"
                >
              </div>
              <div class="browse-btn">{{ $t('kyc.browse_file') }}</div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('asset ownership') }}</span>
          <b-tag
            v-if="form.assetOwnership"
            type="is-primary"
          >
            {{ form.assetOwnership.name }}
          </b-tag>
          <div
            v-if="assetOwnershipOverSize"
            class="is-invalid t-al-center"
          >
            {{ $t('kyc.doc_limit') }} {{ limitFileSizeInMb }} MB
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { KYC_DOC_FILE_SIZE_LIMIT_IN_MB } from '@/constants'
import { sortDataByLanguage } from '@/utils/helper'

export default {
  name: 'Information',
  inject: ['$validator'],
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {}
    },
    workingAtCompanyCountry: {
      type: String,
      required: true
    },
    countries: {
      type: Array,
      default: () => []
    },
    provincesInThailand: {
      type: Array,
      default: () => []
    },
    occupationList: {
      type: Array,
      default: () => []
    },
    averageIncomeList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      proofOfIncomeOverSize: false,
      assetOwnershipOverSize: false,
      limitFileSizeInMb: KYC_DOC_FILE_SIZE_LIMIT_IN_MB
    }
  },
  computed: {
    sortOccupationList () {
      return sortDataByLanguage(this.occupationList, this.$i18n.locale)
    },
    computedForm: function () {
      return Object.assign({}, this.form)
    }
  },
  watch: {
    computedForm: {
      handler: function (newVal, oldVal) {
        if (oldVal.career !== newVal.career) {
          delete this.form.careerOther
        }
      },
      deep: true
    }
  },
  methods: {
    async onUploadDoc (file, key) {
      this[`${key}OverSize`] = false
      if ((file.size / 1000000) > this.limitFileSizeInMb) {
        this[`${key}OverSize`] = true
        this.form[key] = null
      }
    }
  }
}
</script>

<style lang="scss">
.kyc-information-is-expanded {
  .control {
    .select {
      width: 100%;
      select {
        width: 100%;
      }
    }
  }
}
#custom-hight-risk-upload {
  .upload .upload-draggable {
    width: 470px;
  }
  .tag {
    margin-top: 10px;
    span {
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
@media only screen and (max-width: 768px) {
  #custom-hight-risk-upload {
    .upload .upload-draggable {
      width: 100%;
    }
    .tag {
      width: 100%;
    }
  }
}
</style>

<style lang="scss" scoped>
.document-box {
  width: 100%;
  max-width: 70%;
  margin: 0 auto;
}
.example-img {
  text-align: center;
  margin: 20px 0 80px;
}
.dropzone-img {
  &--certificate {
    max-width: 173px;
    width: 100%;
  }
  &--shareholders {
    max-width: 420px;
    width: 100%;
  }
  &--attorney {
    max-width: 236px;
    width: 100%;
  }
}
.browse-btn {
  border-radius: 3px;
  background-color: #069bf9;
  max-width: 250px;
  padding: 13px;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.37px;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.t-al-center {
  text-align: center;
}
@media only screen and (max-width: 768px) {
  .example-img {
    text-align: center;
    margin: 20px 0 30px;
  }
  .document-box {
    max-width: 95%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SummaryOfKYC/components/CustomerInformation.vue